class FormErrors {
  errors: Record<string, string | string[]>;

  constructor() {
    this.errors = {};
  }

  get count() {
    return Object.keys(this.errors).length;
  }

  get(field: string): string | undefined {
    if (this.errors && this.errors[field]) {
      if (typeof this.errors[field] === 'object') {
        return this.errors[field][0];
      }

      return this.errors[field] as string;
    }

    return undefined;
  }

  has(field: string) {
    return this.errors && Object.prototype.hasOwnProperty.call(this.errors, field);
  }

  hasAny() {
    return this.errors && Object.keys(this.errors).length > 0;
  }

  record(errors: Record<string, string | string[]>) {
    this.errors = errors;
  }

  set(field: string, message: string) {
    this.errors[field] = message;
  }

  clear(field?: string | string[]) {
    if (field && this.errors) {
      const fields = Array.isArray(field) ? field : [field];

      fields.forEach((key) => {
        delete this.errors[key];
      });

      return;
    }

    this.errors = {};
  }
}

export default FormErrors;

export {
  FormErrors,
};
